exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#google-pay-button-container{margin-bottom:30px}", ""]);

// exports
